import * as angular from 'angular';
import * as _ from "lodash";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import TiamaDefectMappingServiceName, { TiamaDefectMappingService } from "../../services/defects/tiamaDefectMapping.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import DefectTypeServiceName, { DefectTypeService } from "../../services/defects/defectType.service";
import template from './editTiamaDefectMapping.tpl.html';
import { apsEnums } from '../../shared/dto/aps.enums';

let requires = [LoaderServiceName, TiamaDefectMappingServiceName, NotifyServiceName, DefectTypeServiceName];

export default angular.module('aps.controller.editTiamaDefectMapping', requires)
  .controller('EditTiamaDefectMappingCtrl', editTiamaDefectMappingCtrl)
  .name;

export interface EditTiamaDefectMappingData {
  tiamaDefectId: string;
}

export function openEditTiamaDefectMapping(
  data: EditTiamaDefectMappingData,
  $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'EditTiamaDefectMappingCtrl as vm',
    resolve: {
      data: function () {
        return data;
      }
    }
  }).result;
}

function editTiamaDefectMappingCtrl(
  $modalInstance: mm.foundation.modalInstance,
  data: EditTiamaDefectMappingData,
  loaderService: LoaderService,
  tiamaDefectMappingService: TiamaDefectMappingService,
  notifyService: NotifyService,
  defectTypeService: DefectTypeService
) {
  let vm = this;

  vm.tiamaDefectId = data.tiamaDefectId;

  vm.machineTypes = [
    { value: apsEnums.DataPointConfigType.MX4Counter, text: 'MX4' },
    { value: apsEnums.DataPointConfigType.MultiCounter, text: 'MULTI' },
    { value: apsEnums.DataPointConfigType.McalCounter, text: 'MCAL' }
  ];

  var promise1 = defectTypeService.getDefectTypesAll()
    .then(function (defectTypesAll) {
      vm.defectTypes = defectTypesAll;
    }, notifyService.handleApiErrors);
  loaderService.loadingPromise(promise1);

  var promise = tiamaDefectMappingService.getTiamaDefectMapping(vm.tiamaDefectId)
    .then(function (tiamaDefectMapping) {
      vm.tiamaDefectMapping = tiamaDefectMapping;
    }, notifyService.handleApiErrors);
  loaderService.loadingPromise(promise);

  var postTiamaDefectMapping = function () {
    var promise = tiamaDefectMappingService.updateTiamaDefectMapping(vm.tiamaDefectMapping)
      .then(function () {
        vm.tiamaDefectMapping.defectTypeName = getDefectTypeName(vm.tiamaDefectMapping.defectTypeId);
        var data = {
          action: 'return',
          tiamaDefectMapping: vm.tiamaDefectMapping
        };
        $modalInstance.close(data);
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  var getDefectTypeName = function (defectId: string) {
    var defectType = _.find(vm.defectTypes,
      function (item: any) {
        return item.key === defectId;
      });

    if ((defectType || '') !== '') {
      return defectType.value;
    }
  };

  vm.submitTiamaDefectMapping = function () {
    if (vm.form.$invalid) {
      return;
    }
    postTiamaDefectMapping();
  };

  vm.cancel = function () {
    $modalInstance.close({
      action: 'close',
      tiamaDefectId: vm.tiamaDefectId
    });
  };

  return vm;
}


// WEBPACK FOOTER //
// ./src/app/controllers/tiamaDefectMappings/editTiamaDefectMapping.controller.ts